/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} CharactersInputs */



/**
* | output |
* | --- |
* | "Characters" |
*
* @param {CharactersInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const characters = /** @type {((inputs?: CharactersInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<CharactersInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Caractères")
	if (locale === "de") return /** @type {LocalizedString} */ ("Charaktere")
	if (locale === "it") return /** @type {LocalizedString} */ ("Caratteri")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Персонажи")
	if (locale === "es") return /** @type {LocalizedString} */ ("Personajes")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("人物")
	if (locale === "ja") return /** @type {LocalizedString} */ ("キャラクター")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पात्रों")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Personagens")
	return /** @type {LocalizedString} */ ("Characters")
});